<template>
  <az-container>
    <az-form style="padding: 0px">
      <div class="li-tabela">
        <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                      :pagination.sync="paginacaoInterna" :loading="false"
                      no-data-text="Nenhum documento encontrado"
                      hide-actions class="az-table-list tabela-comparar-hash">
          <template slot="items" slot-scope="props">
            <td>
              <v-tooltip top class="no-mobile">
                <span slot="activator" class="d-inline-block text-truncate max-10">
                  {{ props.item.protocolo | textoSemValor }}
                </span>
                {{ props.item.protocolo | textoSemValor }}
              </v-tooltip>
            </td>
            <td>{{ props.item.documentoEnviado }}</td>
            <td>{{ props.item.hashProtocolo }}</td>
            <td class="table-actions-comparar-hash">
              <input type="file" hidden :ref="props.item.id" @change="compararHashArquivo($event, props.item)"/>
              <div @click.prevent.stop="abrirSelecaoArquivo(props.item)">
                <v-icon size="20" style="margin-right: 5px">upload_file</v-icon>
                Selecionar Arquivo
              </div>
            </td>
            <td>{{ props.item.hashGerado }}</td>
            <td class="comparar-hash-resultado">
              <div v-if="props.item.arquivoComparado">
                <v-icon v-if="props.item.resultado" color="green" size="20">check_circle</v-icon>
                <v-icon v-if="!props.item.resultado" color="red" size="20">cancel</v-icon>
              </div>
            </td>
          </template>
        </v-data-table>
        <div class="az-pagination">
          <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
          <div class="az-select-pagination">
            <span>Linhas por página:</span>
            <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
          </div>
        </div>
      </div>
    </az-form>
  </az-container>
</template>

<script>
import CryptoJS from 'crypto-js';

export default {
  name: 'CompararHashTabela',
  props: ['itens', 'paginacao', 'paginas', 'totalItens'],
  data() {
    return {
      linhasPorPagina: [10, 25, 50, 100],
      colunas: [
        {
          text: 'Protocolo',
          sortable: false,
          align: 'left',
          width: '150px',
          class: 'primary--text'
        },
        {
          text: 'Documento Enviado',
          sortable: false,
          width: '100px',
          align: 'left',
          class: 'primary--text'
        },
        {
          text: 'Hash Protocolado',
          sortable: false,
          width: '250px',
          align: 'left',
          class: 'primary--text'
        },
        {
          text: 'Documento Selecionado',
          sortable: false,
          align: 'left',
          class: 'primary--text'
        },
        {
          text: 'Hash Gerado',
          sortable: false,
          align: 'left',
          class: 'primary--text'
        },
        {
          text: 'Resultado',
          sortable: false,
          align: 'center',
          class: 'primary--text'
        }
      ],
      paginacaoInterna: this.paginacao,
      itensUpload: []
    }
  },
  watch: {
    paginacaoInterna: {
      handler(novoValor) {
        this.$emit('paginar', novoValor)
      },
      deep: true,
    },
  },
  computed: {
    repository() {
      return `repo1:licitacao/compararHash/${this.loki.user.domainId}/itens`
    }
  },
  methods: {
    abrirSelecaoArquivo(item) {
      this.$refs[item.id].click()
    },
    compararHashArquivo(evento, itemSelecionado) {
      var arquivo = evento.target.files[0]
      var reader = new FileReader();
      const itemSelecionadoIndex = this.itens.findIndex(item => item.id === itemSelecionado.id)

      reader.onload = (event) => {
        var binary = event.target.result;
        var hash = CryptoJS.MD5(CryptoJS.enc.Latin1.parse(binary)).toString();
        var md5 = hash.toString(CryptoJS.enc.Hex)
        const resultado = itemSelecionado.hashProtocolo == md5
        itemSelecionado.hashGerado = md5
        itemSelecionado.resultado = resultado
        itemSelecionado.arquivoComparado = true
        this.itens[itemSelecionadoIndex] = itemSelecionado
      };
      reader.readAsBinaryString(arquivo)
    }
  },
}
</script>

<style scoped lang="stylus">

.az-container .tabela-comparar-hash tbody tr td
  padding 0px 10px !important


.table-actions-comparar-hash
  .table-actions
    cursor pointer

.comparar-hash-resultado
  text-align center

.max-10
  max-width 10vw

@media (max-width: 720px)
  .table-actions-comparar-hash
    td:nth-of-type(1):before
      content: "Protocolo:"

    td:nth-of-type(2):before
      content: "Documento Enviado:"

    td:nth-of-type(3):before
      content: "Hash Protocolado:"

    td:nth-of-type(4):before
      content: "Documento Selecionado:"

    td:nth-of-type(5):before
      content: "Hash Gerado:"

    td:nth-of-type(6):before
      content: "Resultado:"

</style>